import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { RecoilRoot } from "recoil";
import { GlobalStyle } from "./components/styles";
import "./i18n";
import { initFontScale } from "./utils/fontScale";
// 이외에 필요한 스타일 파일이 있다면 import 해주세요...

declare global {
  interface Window {
    webkit?: any;
    Android?: any;
    iOSGoogleLogin?: any;
    iOSAppleLogin?: any;
    requestIOSError?: (message: string) => void;
    getTokenIOS?: any;
    isPermissionedPhoto?: any;
    confirmPurchaseAndroid?: any;
    androidPurchasedFailed?: () => void; // 안드로이드 결제 에러
    androidPurchasedCanceled?: () => void; // 안드로이드 결제 취소
    requestIOSPurchase?: any;
    failIOSAlarm?: any;
    getNotificationStatus?: any;
    setFirst?: any;
    iOSAddPhoto?: any;
    iOSAddProfile?: any;
    iOSPurchasedFailed?: any;
    clearLocalStorage?: any;
    closeModalAtAndroid?: any;
    getFcmToken?: (token: string) => void; // FCM 토큰 전달
  }
}

// 2026-08-15 글씨 크기(노안 대응)를 렌더 전에 반영한다. 렌더 후에 하면 기본 크기로
// 한 번 그려졌다가 커지면서 깜빡인다.
initFontScale();

ReactDOM.render(
  <StrictMode>
    <RecoilRoot>
      <GlobalStyle />
      <App />
    </RecoilRoot>
  </StrictMode>,
  document.getElementById("root")
);
